"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_210)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_210`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000488281H30V24H-6V0.000488281Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 0V11.7204L-6 12.0123V0H30Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.7632 8.28027L12 13.0435L7.23674 8.28027C6.59942 9.22493 6.25954 10.3388 6.26087 11.4783V13.0435C6.26087 15.5568 7.88488 17.6977 10.1385 18.4726C9.83774 19.0621 9.88843 19.7978 10.3292 20.3479L12.0348 18.9811L13.7404 20.3479C14.1864 19.7914 14.2334 19.0447 13.9207 18.4517C16.1436 17.6599 17.7393 15.5348 17.7393 13.0435V11.4783C17.7405 10.3388 17.4005 9.22495 16.7632 8.28027Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0001 17.2175C9.6986 17.2175 7.82617 15.3451 7.82617 13.0436V11.4784C7.82617 9.17687 9.6986 7.30444 12.0001 7.30444C14.3015 7.30444 16.174 9.17687 16.174 11.4783V13.0436C16.174 15.3451 14.3015 17.2175 12.0001 17.2175Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.6087 13.0435V11.4783C14.6087 10.0398 13.4385 8.86963 12 8.86963C10.5616 8.86963 9.39136 10.0398 9.39136 11.4783V13.0435L12 13.5653L14.6087 13.0435Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.39136 13.0437C9.39136 14.4822 10.5616 15.6524 12 15.6524C13.4385 15.6524 14.6087 14.4822 14.6087 13.0437H9.39136Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.1305 7.30459C15.1305 6.4401 14.4297 5.73936 13.5652 5.73936C13.1801 5.73885 12.8084 5.88092 12.5218 6.13817V5.21757H13.0436V4.17413H12.5218V3.65234H11.4784V4.17413H10.9566V5.21757H11.4784V6.13817C11.1917 5.88093 10.82 5.73886 10.4349 5.73936C9.57036 5.73936 8.86963 6.4401 8.86963 7.30459C8.86963 7.76802 9.07121 8.18434 9.39142 8.47101V9.39161H14.6088V8.47101C14.9289 8.18434 15.1305 7.76809 15.1305 7.30459Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_210`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SMFlag };
